// i18n area 'apps' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.es-ES.meta.json.
import type { enUS } from './apps'

export const esES: typeof enUS = {
  apps: {
    title: 'Apps',
    create: 'Crear app',
    createTitle: 'Crear app',
    editTitle: 'Editar app',
    name: 'Nombre',
    nameHint: 'DNS-1123, único en el scope — inmutable tras la creación.',
    node: 'Nodo',
    nodeHint: 'El nodo miembro que la sirve — placement explícito (el scheduler llega después).',
    image: 'Imagen',
    editImageHint: 'Una nueva referencia se re-resuelve a través del padrón — el gesto de pin/rollback.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'El digest se mueve solo bajo orden.',
    policyTrackingHint: 'Rolling automático cuando un refresh mueve el branch.',
    archMovePolicy: 'Movimiento cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Qué pasa si la app se mueve a un nodo de otra arquitectura: refuse rechaza el movimiento, reresolve vuelve a resolver el lockfile desde el branch en la arch nueva — el contenido cambia, y la respuesta nombra el cambio de digest.',
    network: 'Red',
    networkHint: 'Conexión L3 untagged: una red lógica de fabric (recomendada — gateway/DNS desde su fuente única), una overlay, o un bridge host desnudo (desaconsejado).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'bridge host:',
    ipAssignment: 'Asignación de IP',
    ipStatic: 'Estática',
    ipAuto: 'Automática (IPAM)',
    ipAssignmentHint_static: 'La dirección se da ahora, a mano.',
    ipAssignmentHint_auto: 'El IPAM elige una dirección libre de los rangos de la red reservados a TVirt.',
    bridgeDiscouraged: 'Bridge host desnudo — DESACONSEJADO: TVirt no sabe nada de su direccionamiento, así que gateway y DNS deben darse a mano. La vía recomendada es una red lógica de fabric.',
    ip: 'IP',
    ipHint: 'IPv4 estática dentro de la subred de la conexión.',
    ipCidrHint: 'En forma CIDR sobre un bridge desnudo (ej. 192.168.1.10/24) — no hay de dónde derivar el prefijo.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manual — un bridge desnudo no deriva nada.',
    dnsServers: 'Servidores DNS',
    dnsManualHint: 'Manuales, separados por comas — al menos uno.',
    rootKind: 'Root',
    rootEphemeral: 'efímera',
    rootPersistent: 'persistente',
    rootEphemeralHint: 'Recreada desde la imagen en cada recreación; vive en el storage efímero de clúster.',
    rootEphemeralHintNamed: 'Recreada desde la imagen en cada recreación; vive en el storage efímero de clúster ({name}).',
    rootPersistentHint: 'Sobrevive a los reinicios; vive en el storage que elija.',
    rootStorage: 'Storage root',
    editRootStorageHint: 'La root se re-renderiza en el nuevo pool — los datos existentes NO se mueven solos.',
    volumes: 'Volúmenes',
    volumeAdd: 'Añadir volumen',
    volumeName: 'Nombre',
    volumeMountPath: 'Ruta de mount',
    volumeKind: 'Tipo',
    volumeStorage: 'Storage',
    devices: 'Dispositivos',
    deviceClassHint: 'Se pide una CLASE (una etiqueta gpu-device o usb-device), nunca un dispositivo concreto: el nodo declarado debe tener uno marcado para las Apps. Varias Apps pueden usar el mismo dispositivo — un contenedor lo comparte, no se lo quita al host.',
    deviceSlot: 'Slot',
    deviceTag: 'Etiqueta',
    deviceValue: 'Clase',
    deviceUnresolved: 'ahora mismo no se resuelve nada',
    noDeviceTags: 'Todavía no hay ninguna etiqueta de tipo gpu-device o usb-device: crea una y asígnala a los dispositivos marcados para las Apps.',
    env: 'Entorno',
    envHint: 'Una CLAVE=valor por línea.',
    secretEnvTitle: 'Variables secretas',
    secretEnvNotice: 'Un valor secreto no vuelve nunca de la API: nadie lo relee, ni siquiera quien lo escribió. En el checkpoint viaja sellado con la masterpass, así que una restauración sin la masterpass pedirá volver a escribirlo.',
    secretEnvPromote: 'Haga secreta una de las variables escritas más arriba:',
    secretEnvAdd: 'Añadir variable secreta',
    secretEnvName: 'Nombre',
    secretEnvValue: 'Valor',
    secretEnvKept: 'conservado — déjelo vacío para no cambiarlo',
    secretEnvWithdrawWarning: 'Para dejar de tratar como secreta una variable que ya lo es, escríbale un valor nuevo: retirar la marca por sí sola sería una manera de LEER lo que no sale del store. Eliminarla, en cambio, la borra.',
    secretEnvChip: 'secreto',
    startNow: 'Arrancar enseguida (si no, la app nace parada)',
    deletePersistentIntro: 'Esta app tiene datos persistentes — elija qué hacer con ellos:',
    deleteKeepData: 'Mantener los datos (los directorios quedan en sus storage, huérfanos)',
    deletePurgeData: 'Eliminar también los datos',
    phase: 'Fase',
    phase_running: 'En ejecución',
    phase_stopped: 'Parada',
    phase_error: 'Error',
    phase_unknown: 'Desconocida',
    desiredState: 'Deseado',
    wantedRunning: 'en ejecución',
    wantedStopped: 'parada',
    start: 'Arrancar',
    stop: 'Parar',
    restart: 'Reiniciar',
    refreshImage: 'Actualizar imagen (adoptar el nuevo @current)',
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Ningún output capturado.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'La App no está en ejecución — una shell necesita un contenedor vivo. Sus logs se leen en cualquier estado.',
    shellConnect: 'Conectar',
    shellDisconnect: 'Desconectar',
    shellExited: 'La sesión terminó con código de salida {code}.',
    shellEndedWithoutStatus: 'La sesión terminó sin un estado de salida: {reason}',
    shellRevoked: 'El ticket de la sesión ya no es válido — caducó, o el inicio de sesión que lo abrió fue revocado.',
    shellHint: 'Haz clic en el recuadro negro y escribe: las teclas llegan al contenedor. Ctrl+C y las flechas funcionan; exit cierra la shell.',
    shellStatus: {
      connecting: 'Conectando…',
      connected: 'Conectada',
      ended: 'Terminada'
    },
    deleteRunningError: '{name} se desea en ejecución — párela primero.',
    tabs: {
      general: 'General',
      image: 'Imagen',
      network: 'Red',
      storage: 'Storage',
      devices: 'Dispositivos',
      observed: 'Observado'
    },
    attachment: 'Conexión',
    runningDigest: 'Digest en ejecución',
    lastError: 'Último error',
    reportObservedAt: 'Último report del worker',
    desiredStateLock: 'Lo gobiernan las acciones Arrancar/Parar — nunca una edición directa.',
    ipEditDisabledHint: 'Editable solo con asignación estática.',
    derivedFromNetworkHint: 'Derivado de la fuente única de la red — manual solo en un bridge desnudo con IP estática.',
    ephemeralUnset: 'no configurado',
    ephemeralMissing: 'El storage efímero de las Apps no está configurado — crear una app con piezas efímeras (root o volúmenes) se rechaza hasta que se configure.',
    ephemeralCurrent: 'Storage efímero de las Apps: {name}',
    ephemeralMissingCreate: 'Esta app tiene piezas efímeras pero el storage efímero de las Apps no está configurado — la creación será rechazada. Configúrelo antes desde el banner de la página Apps.',
    setEphemeral: 'Establecer storage efímero',
    changeEphemeral: 'Cambiar storage efímero',
    setEphemeralTitle: 'Establecer el storage efímero de las Apps',
    changeEphemeralTitle: 'Cambiar el storage efímero de las Apps',
    ephemeralStorageHint: 'DEFAULT de clúster: el pool dir-like donde viven las roots y los volúmenes efímeros de cada app, salvo override declarado por la app. Un cambio no es en caliente y no reinicia nada: vale desde el próximo start de cada app — los datos efímeros no se mueven.',
    ephemeralPool: 'Pool de storage',
    ephemeralOverride: 'Storage efímero (override por app)',
    ephemeralOverrideInherit: 'Heredar el default de clúster',
    ephemeralOverrideInheritNamed: 'Heredar el default de clúster ({name})',
    ephemeralOverrideHint: 'Pool por app para la root y los volúmenes efímeros — deje vacío para heredar el default de clúster. Cambiarlo no es en caliente y no reinicia nada: vale desde el próximo start (datos efímeros renacidos vacíos en el nuevo pool) y requiere el permiso app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Todos los branches',
    imageBranchHint: 'Limita las imágenes a las que este branch nombra; sin branch se ven todas las del repositorio.',
    imageDigestHint: 'El contenido: se elige de la tabla de digests, que lleva su procedencia y su arquitectura. El mismo branch ofrece uno por arquitectura, y no son intercambiables.',
    imageLockfile: 'Referencia resuelta',
    imageNoImages: 'Ninguna imagen en caché para este repositorio — descarga una desde Imágenes OCI.',
    imageHeadNotCached: 'no está en caché — se descarga al arrancar',
    imageNoRegistries: 'Ningún repositorio registrado: registra uno para poder elegir una imagen.',
    imageChosenHint: 'La imagen se elige en la cascada del diálogo de edición: la referencia nunca se escribe a mano.',
    registerRepositoryHint: 'Registrar no descarga nada: hace observable un repositorio, para que la imagen se elija sin salir de este diálogo.',
    registerRepositoryBranchHint: 'Opcional: el primer branch a observar (p. ej. latest).',
    registerRepositoryElsewhere: 'El repositorio que buscas no está registrado: el registro se hace en la sección Imágenes OCI, por quien tenga el permiso.'
  },
  cts: {
    createAction: 'Crear CT',
    createTitle: 'Crear un container desde un template',
    createError: 'El container no se ha creado',
    template: 'Template CT',
    noTemplates: 'Ningún template CT — importe uno desde Templates CT',
    resources: 'Recursos',
    node: 'Nodo',
    phase: {
      defined: 'Nunca encendido',
      materializing: 'En materialización',
      ready: 'Listo',
      starting: 'Arrancando',
      running: 'En ejecución',
      stopping: 'Deteniéndose',
      stopped: 'Detenido',
      deleting: 'En eliminación',
      error: 'En error'
    },
    actions: {
      start: 'Arrancar',
      stop: 'Detener',
      restart: 'Reiniciar',
      markTemplate: 'Promover a template CT',
      error: 'La acción fue rechazada'
    },
    markTemplate: {
      confirmTitle: "¿Promover '{name}' a template CT?",
      confirmBody: 'El container deja esta lista y pasa a Templates CT, listo de inmediato para generar nuevos CT. Sus metadata siguen editables, y puede devolverlo a CT en cualquier momento.',
      confirm: 'Promover',
      moved: "'{name}' ahora es un template CT — lo encontrará en Templates CT."
    },
    stopCause: {
      api: 'Detenido desde TVirt',
      'ct-exit': 'El container salió por sí solo',
      'host-reboot': 'Murió con el reinicio del nodo',
      'start-failed': 'El arranque falló — el error del task dice qué falta y cómo se arregla'
    },

    console: 'Consola',
    consoleUnavailable: 'El container no está en ejecución — una consola necesita un container vivo. Sus logs, en cambio, se leen en cualquier estado.',
    consoleNoTemplate: 'Un template no se ejecuta nunca, así que no tiene consola: cree un CT a partir de él y abra la suya.',
    consoleConnect: 'Conectar',
    consoleDisconnect: 'Desconectar',
    consoleReconnect: 'Reconectar',
    consoleTakenBy: 'Otro operador ha tomado esta consola ({user}). Una consola por container: reconectarse se la devuelve.',
    consoleHint: 'Haga clic en el recuadro negro y escriba: las teclas llegan al container. Ctrl+C y las flechas funcionan.',
    consoleEndpointDown: 'El punto de acceso de la consola no se abre en el nodo que sirve el container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'El container no está en ejecución — una shell necesita un container vivo. Sus logs se leen en cualquier estado.',
    shellNoTemplate: 'Un template nunca se ejecuta, así que no tiene shell: crea un CT a partir de él y abre la suya.',
    shellConnect: 'Conectar',
    shellDisconnect: 'Desconectar',
    shellExited: 'La sesión terminó con código de salida {code}.',
    shellEndedWithoutStatus: 'La sesión terminó sin un estado de salida: {reason}',
    shellRevoked: 'El ticket de la sesión ya no es válido — caducó, o el inicio de sesión que lo abrió fue revocado.',
    shellHint: 'Haz clic en el recuadro negro y escribe: las teclas llegan al contenedor. Ctrl+C y las flechas funcionan; exit cierra la shell.',
    shellStatus: {
      connecting: 'Conectando…',
      connected: 'Conectada',
      ended: 'Terminada'
    },
    rootPassword: 'Contraseña de root',
    rootPasswordHint: 'Se escribe una vez en el rootfs copiado (como hash, no se vuelve a mostrar). Las imágenes de las distribuciones no traen contraseña de root: sin ella, la shell es la única entrada.',
    sshKeys: 'Claves SSH públicas de root',
    sshKeysHint: 'Una clave pública OpenSSH por línea, en root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Conectando…',
      connected: 'Conectada',
      reconnecting: 'Reconectando…'
    },
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Ningún output capturado.',
    logsSource: 'Qué log',
    logsSourceConsole: 'La consola del init del container — por qué el servicio de dentro no arrancó',
    logsSourceSupervisor: 'El supervisor liblxc — por qué el container no llegó nunca a arrancar',
    logsNeverStarted: 'Nunca se ha arrancado, así que todavía no hay nada registrado — arránquelo, y los logs estarán ahí aunque el arranque falle.',
    logsNoTemplate: 'Un template no se ejecuta nunca, así que nunca ha registrado nada.',
    logsError: 'Los logs no se han capturado',

    tabs: {
      general: 'General',
      hardware: 'Hardware',
      network: 'Red',
      provenance: 'Procedencia'
    },
    templateFlag: 'Template CT',
    templateLock: 'Se cambia solo con las acciones Promover / Devolver a CT — nunca una edición directa.',
    sourceLock: 'Procedencia, registrada al nacer — nunca reescrita; una fuente muerta deja la referencia desnuda.',
    storageLock: 'Fijado en la creación — mover el rootfs es un round futuro.',
    startedAt: 'Arrancado',
    lastStop: 'Última parada',
    editNicsTitle: 'Editar redes',
    nicDisconnected: 'desconectada'
  },
  ctTemplates: {
    title: 'Templates CT',
    importAction: 'Importar desde catálogo',
    importTitle: 'Importar template CT desde el catálogo',
    importSubmit: 'Importar',
    importError: 'El import fue rechazado',
    importHint: 'Materializar copia el rootfs al storage elegido — el fichero de catálogo queda intacto. Para añadir nuevos ficheros, súbalos antes dentro de un catálogo.',
    sourceFile: 'Fichero de template CT',
    sourceFileHint: 'Los ficheros ct-rootfs del catálogo elegido, solo los listos',
    noFiles: 'Ningún fichero ct-rootfs listo en este catálogo — suba uno desde la página del catálogo',
    source: 'Fichero de origen',
    rootfsStorage: 'Storage del rootfs',
    rootfsStorageHint: "Donde vive el árbol rootfs extraído — un storage con filesystem y espacio libre suficiente para el tamaño extraído más un margen de aproximadamente 1 GiB (de lo contrario, el import falla).",
    resources: 'Recursos',
    cores: 'vCPU',
    memoryMiB: 'Memoria (MiB)',
    cpuLimit: 'Límite de CPU',
    cpuLimitHint: 'Equivalentes de cores del host (ej. 1.5); vacío = sin tope',
    cpuUncapped: 'sin tope',
    cpuWeight: 'Peso de CPU',
    hostname: 'Hostname',
    hostnameHint: 'Vacío = el nombre del CT',
    nameservers: 'Nameservers DNS',
    dnsHint: 'Separados por comas; vacío = hereda los del host',
    searchDomains: 'Dominios de búsqueda DNS',
    dnsInherited: 'Heredado del host',
    networks: 'Redes',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'En materialización',
      ready: 'Listo',
      deleting: 'En eliminación',
      error: 'Error'
    },
    exportAction: 'Exportar al catálogo',
    exportTitle: 'Exportar al catálogo',
    exportSubmit: 'Exportar',
    exportError: 'El export fue rechazado',
    exportHint: 'Empaqueta el rootfs materializado en un NUEVO fichero ct-rootfs en el catálogo elegido — el template queda intacto.',
    exportName: 'Nombre del fichero',
    exportNameHint: 'Vacío = <template>-export-<n>',
    markCt: {
      action: 'Devolver a CT',
      confirmTitle: "¿Devolver '{name}' a CT?",
      confirmBody: 'El template deja esta lista y vuelve a la lista CT, arrancable de nuevo. Hasta que no lo promueva de nuevo, no se pueden crear CT a partir de él.',
      confirm: 'Devolver a CT',
      moved: "'{name}' vuelve a ser un CT — lo encontrará en la lista CT."
    }
  },
  oci: {
    registriesTitle: 'Registries OCI',
    imagesTitle: 'Imágenes OCI',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Genérico',
    providerImmutableHint: 'El provider es inmutable tras la creación — un provider distinto es un nuevo registry.',
    url: 'URL',
    urlHintPreset: 'Precargado por el provider — sobrescriba solo para mirrors.',
    urlHintRequired: 'Obligatorio para los registries genéricos: la URL base https://.',
    urlHintEcr: 'Obligatorio: los endpoints ECR son por cuenta/por región — no existe un preset.',
    credential: 'Credencial',
    credentialNone: 'Acceso anónimo',
    credentialHint: 'Una entrada de keystore usuario-y-contraseña; los workers la resuelven en el momento del uso — nunca auth files por nodo.',
    nameHint: 'Nombre tipo host (docker.io, registry.intra); único por scope, inmutable',
    addRegistry: 'Añadir registry',
    addRegistryTitle: 'Añadir registry OCI',
    verify: 'Verificar',
    verifyState: 'Verificación',
    verified: 'Verificado',
    verifyFailed: 'Fallida',
    neverVerified: 'Nunca verificado',
    registryInUseError: "'{name}' aún tiene repositorios registrados — elimínelos primero.",
    repositories: 'Repositorios',
    repositoriesHint: 'Registrar observa los branches (tags OCI) — no descarga nada. El refresh resuelve cada branch observado y mantiene el reflog.',
    noRepositories: 'Ningún repositorio registrado en este registry.',
    registerRepository: 'Registrar repositorio',
    repoPath: 'Ruta',
    repoPathHint: "Ruta del repositorio en el registry, ej. 'example' o 'library/nginx'",
    branches: 'Branches',
    branchesHint: 'Branches observados (tags OCI), separados por comas — ej. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Resuelto AHORA: el pull descarga el digest al que el branch apunta hoy.',
    refresh: 'Actualizar',
    deleteRepository: 'Eliminar repositorio',
    reflogCount: '{n} anteriores',
    noResolutions: 'Nunca actualizado — ninguna resolución observada.',
    refreshFailed: 'Última actualización fallida ({when})',
    loadError: 'No se pudieron cargar los repositorios.',
    reference: 'Referencia',
    digest: 'Digest',
    digestHint: 'sha256:… — la imagen exacta, sin branch (detached)',
    size: 'Tamaño',
    nodes: 'Nodos',
    detached: 'detached',
    detachedHint: 'Descargada por digest, sin branch — el control de drift no se aplica.',
    pulledAt: 'Descargada',
    pull: 'Pull',
    pullTitle: 'Pull de imagen',
    pullHint: 'Pre-warming, nunca un prerrequisito: un pull por branch resuelve AHORA y descarga ESE digest; un pull por digest es detached.',
    pullError: 'El pull fue rechazado',
    pullMode: 'Pull por',
    pullModeBranch: 'Branch (resolver ahora)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'El default honesto: como apt install, reejecutado más tarde puede dar una imagen distinta.',
    pullModeDigestHint: 'Digest exacto — reproducibilidad y rollback; renuncia al control de drift.',
    importFromRegistry: 'Importar desde registry',
    importFromCatalog: 'Importar desde catálogo',
    importCatalogTitle: 'Importar imagen OCI desde catálogo',
    importCatalogHint: 'La vía air-gapped: un archivo oci-image listo (tar/tar.gz — docker-archive u oci-archive) se materializa en el store de imágenes con la referencia catalog/<catálogo>/<file>@<digest>; las apps lo consumen como cualquier otra imagen. Los archivos se suben en los catálogos — esta sección solo importa.',
    importCatalogFile: 'Archivo',
    importCatalogFileHint: 'Los ficheros oci-image listos del catálogo elegido.',
    importCatalogNoFiles: 'Ningún archivo oci-image listo en este catálogo — suba uno desde el detalle del catálogo.',
    importCatalogError: 'El import fue rechazado',
    registry: 'Registry',
    repository: 'Repositorio',
    cacheMissing: 'La caché OCI de clúster no está configurada — los pulls se rechazan hasta que se establezca un pool de storage.',
    setCache: 'Establecer caché',
    setCacheTitle: 'Configurar la caché OCI',
    setCacheHint: 'El pool DEFAULT a nivel de clúster que aloja los blobs de las imágenes descargadas — un scope puede hacer override con su propio pool (página Scopes). Cambiarlo no es en caliente y no reinicia nada, y no mueve los blobs: reaparecen lazy en el próximo start/uso.',
    cachePool: 'Pool de storage',
    changeCache: 'Cambiar caché',
    changeCacheTitle: 'Cambiar el pool de la caché OCI',
    cacheCurrent: 'Caché OCI del clúster (default): {name}',
    sectionOverview: 'Vista general',
    sectionRepositories: 'Repositorios',
    sectionExplore: 'Explorar',
    exploreHint: 'Búsqueda remota en vivo sobre el registry — Docker Hub completa (descripción, descargas, estrellas), otros providers best-effort. Seleccione un resultado para leer su descripción completa y hojear sus tags remotos; desde un tag puede añadir la referencia a un repositorio TVirt.',
    exploreSearch: 'Buscar',
    exploreUnsupported: 'Este provider no soporta la búsqueda.',
    exploreNoResult: 'Ningún repositorio coincidente.',
    exploreNoTags: 'Ningún tag coincidente en este repositorio.',
    exploreOfficial: 'Oficial',
    explorePulls: 'Descargas',
    exploreStars: 'Estrellas',
    exploreUpdated: 'Actualizado {when}',
    exploreLoadMore: 'Cargar más',
    exploreSelectHint: 'Seleccione un resultado: la descripción completa y los tags remotos se cargan aquí.',
    exploreNoDescription: 'Ninguna descripción disponible de este provider.',
    exploreTagsTitle: 'Tags remotos',
    exploreTagFilter: 'Buscar tags',
    exploreAddToRepo: 'Añadir a repositorio',
    exploreAdded: '{path}:{tag} ahora está en seguimiento — vea la sección Repositorios.',
    addBranch: 'Añadir branch',
    purgeRequiredTitle: "¿Eliminar '{name}' y sus imágenes?",
    purgeRequiredBody: 'Ninguna app consume este repositorio, pero aún existen imágenes descargadas: eliminarlo quita también sus registros, y los blobs en caché pasan al garbage collector.',
    purgeConfirm: 'Eliminar también las imágenes',
    providerSelectHint: 'Seleccione el tipo de registry: la tarjeta cuenta el preset y el uso.',
    providerDesc: {
      dockerhub: 'El registry público de Docker: URL precargada, búsqueda completa con descripciones y conteos.',
      ghcr: 'GitHub Container Registry: URL precargada; las cuentas usan un personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpoints por cuenta/por región — hay que indicar la URL.',
      quay: 'El registry Red Hat Quay: URL precargada.',
      generic: 'Registry self-hosted (Harbor, registry:2, …): la URL https:// es obligatoria.'
    },
    layerCount: 'Layers',
    verifiedAt: 'Última verificación',
    verifyOk: 'Resultado',
    verifyMessage: 'Mensaje de verificación',

    // El modelo #348/R39: la imagen ES el digest — el contenido — y registry, repositorio y branch son los NOMBRES que lo alcanzan.
    head: 'Head',
    heads: 'Cabezas por arquitectura',
    listDigest: 'Digest de la lista',
    neverResolved: 'Nunca resuelto',
    totalSize: 'Tamaño total',
    reflogTitle: 'Historial de resoluciones',
    usedBy: 'Usado por',
    usageLockfile: 'lockfile',
    usageRunning: 'en ejecución',
    evictable: 'desalojable',
    evict: 'Desalojar de la caché',
    evictHeadTitle: '¿Desalojar {digest}?',
    evictHeadBody: 'Es la resolución actual de al menos un colector: desalojarlo es legítimo — es solo caché, el branch remoto lo sigue sirviendo — pero no debe pasar por error. El blob es UNO: el desalojo vacía todos los colectores que lo comparten.',
    evictConfirm: 'Desalojarlo igualmente',

    arch: 'Arquitectura',
    names: 'Nombres',
    noNames: 'sin nombre',
    views: 'Vistas',
    lastView: 'última vista',
    evictLastViewTitle: '¿Quitar la última referencia a {digest}?',
    evictLastViewBody: 'Es la última vista sobre este contenido: al quitarla la imagen deja de existir en TVirt y se liberan los bytes ({size}). Es el docker image rm del modelo — no un efecto secundario, la operación misma.',
    branchesTabHint: 'Los branches observados de este repositorio: de cada uno las cabezas de hoy — una por arquitectura — la cronología de los refrescos y cuántas de las imágenes que ha nombrado están en caché. El refresco es el «git fetch» del repositorio: resuelve todos sus branches de una vez.',
    noBranches: 'Ningún branch observado en este repositorio.',
    stopObserving: 'Dejar de observar el branch',
    pullBranch: 'Descargar a la caché la cabeza del branch (el refresh resuelve, esto descarga)',
    pullDigest: 'Descargar a la caché este digest',
    imageCount: 'Imágenes',
    deleteBranchPurgeTitle: '¿Dejar sin nombre las imágenes de {name}?',
    deleteBranchPurgeBody: 'Ninguna app nombra este branch, pero algunas imágenes solo se alcanzan por él: al eliminarlo quedan en caché sin nombre, listadas entre las imágenes del repositorio y desalojables a mano.',
    deleteBranchPurgeConfirm: 'Eliminar y dejar las imágenes sin nombre',
    imagesTabHint: 'Las imágenes de este repositorio — los contenidos, es decir los digests — visibles también sin elegir un branch. Una imagen es única por clúster: los nombres que la alcanzan pueden ser varios.',
    noImages: 'Ninguna imagen de este repositorio está materializada en caché.',
    deleteRepositoryTitle: '¿Eliminar {name}?',
    deleteRepositoryBody: 'Desaparecen el repositorio y sus branches, con su cronología. Las imágenes siguen en caché: solo pierden este nombre. Un repositorio nombrado por una app no se elimina.',
    provenanceCatalog: 'catálogo',
    refreshedAt: 'Actualizado',
    neverRefreshed: 'Nunca actualizado',
    sectionBranches: 'Branches',
    sectionImages: 'Imágenes',
    repositoriesGovernedElsewhere: 'Aquí los repositorios solo se miran: registrarlos, actualizarlos, observar sus branches y desalojar sus imágenes se hace en la sección Imágenes OCI.',
    gotoImages: 'Ir a Imágenes OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Contenedores',
    instances: 'Instancias',
    instancesTooltip: '{running} en ejecución, {error} con error',
    placement: 'Ubicación',
    spread: 'distribución',
    ha: 'HA',
    templateRevision: 'revisión',
    deleting: 'Eliminándose',
    empty: 'Ningún pod — crea una app (un contenedor) o un pod desde la CLI (create-pod).',
    openInstances: 'Abrir las instancias',
    rollingRestart: 'Reinicio escalonado',
    scale: 'Escalar',
    scaleTitle: 'Escalar {name}',
    scaleHint: 'Número de instancias (0–64): hacia arriba nace el ordinal libre más bajo, hacia abajo se retira el más alto y sus datos persistentes se conservan.',
    scaleError: 'El escalado ha fallado',
    replicas: 'Réplicas',
    deleteRunningError: '{name} está en ejecución — detenlo primero.',
    deleteInstancesIntro: 'Se eliminarán las {count} instancias.',
    stateRunning: 'En ejecución',
    stateStopped: 'Detenido',
    editor: {
      createTitle: 'Crear Pod',
      create: 'Crear Pod',
      editTitle: 'Editar Pod',
      nameHint: 'DNS-1123, 58 caracteres como máximo — las instancias se llaman <nombre>-<índice>; inmutable tras la creación.',
      restartPolicy: 'Política de reinicio',
      restartPolicyHint_always: 'El nodo reinicia cualquier contenedor que haya salido, con backoff exponencial (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Solo se reinicia un contenedor que sale con código distinto de cero; la salida 0 queda en reposo.',
      restartPolicyHint_never: 'Un contenedor que ha salido se deja como está — la instancia termina succeeded o failed.',
      grace: 'Gracia (s)',
      graceHint: 'El límite SIGTERM → SIGKILL de una parada.',
      hostname: 'Nombre de host',
      hostnameHint: 'Vacío = el nombre de la instancia.',
      hostnameDefault: 'el nombre de la instancia',
      sharePid: 'Compartir el espacio de nombres PID entre los contenedores',
      containersIntro: 'Los contenedores init se ejecutan hasta el final, en orden, antes de que arranquen los contenedores; los contenedores comparten la red de la instancia (una IP, localhost entre ellos).',
      initContainers: 'Contenedores init',
      initAdd: 'Añadir contenedor init',
      initHint: 'Cada uno debe salir con 0; un fallo deja la instancia en error y el nodo lo reintenta con backoff.',
      containerAdd: 'Añadir contenedor',
      atLeastOne: 'Un Pod necesita al menos un contenedor.',
      duplicateNames: 'Los nombres de los contenedores deben ser únicos en el Pod (contenedores init incluidos).',
      containerName: 'Nombre del contenedor',
      containerInvalid: 'Este contenedor está incompleto: nombre (DNS-1123), imagen, montajes sobre volúmenes declarados, límites y sonda numéricos.',
      command: 'Comando',
      commandHint: 'Sustituye el entrypoint de la imagen — un argumento por línea, nunca una cadena de shell.',
      args: 'Argumentos',
      argsHint: 'Uno por línea (el CMD de la imagen si está vacío).',
      mounts: 'Montajes',
      mountAdd: 'Añadir montaje',
      mountNoVolumes: 'Declara antes un volumen en la pestaña Almacenamiento.',
      readOnly: 'solo lectura',
      resources: 'Límites',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (p. ej. 1.5)',
      memory: 'Memoria (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda de vitalidad',
      healthCmd: 'Comando de la sonda',
      healthCmdHint: 'Ejecutado dentro del contenedor por el nodo en cada tick de supervisión — un argumento por línea; salida 0 = sano.',
      healthTimeout: 'Tiempo límite (s)',
      healthRetries: 'Reintentos',
      healthRetriesHint: 'Fallos consecutivos antes de que el nodo reinicie el contenedor.',
      ips: 'Direcciones estáticas',
      ipsHint: 'Una por instancia, en orden de ordinal — un escalado más allá de la lista se rechaza.',
      instance: 'instancia',
      volumesHint: 'Los volúmenes son del Pod; la ruta de montaje es de cada contenedor (pestaña Contenedores).',
      spread: 'Distribución',
      spreadHint_preferred: 'Instancias en nodos distintos cuando sea posible.',
      spreadHint_required: 'Instancias en nodos distintos, o el escalado se rechaza.',
      spreadHint_none: 'Solo el decisor.',
      ha: 'Alta disponibilidad (opt-in)',
      haHint: 'Cada pieza persistente en storage compartido; si el nodo muere, el decider HA recrea las instancias en otro miembro (failover automático, como las VM HA).',
      yes: 'sí',
      no: 'no'
    },
    detail: {
      container: 'Contenedor',
      actions: 'Acciones',
      ready: 'Listo',
      notReady: 'No listo',
      restarts: 'Reinicios',
      lastRestartAt: 'Último reinicio:',
      backoffUntil: 'Reintento a las',
      stateAbsent: 'ausente',
      stateRunning: 'en ejecución',
      stateTerminated: 'terminado',
      stateWaiting: 'en espera',
      init: 'init',
      noInstances: 'Sin instancias (réplicas 0).',
      ha: 'HA',
      haHint: 'Failover automático: si el nodo muere, el decider HA recrea la instancia en otro miembro (cada pieza persistente en storage compartido).',
      authority: 'Authority (nodo)',
      homeless: 'sin authority',
      homelessHint: 'Una restauración desde checkpoint deja fuera la authority (#380): ningún nodo la sirve hasta que escales el Pod (aunque sea al mismo número de réplicas).',
      restartContainer: 'Reiniciar solo este contenedor (el pod sigue arriba)',
      divergingHint: 'El estado deseado de esta instancia difiere del predeterminado del Pod (PD-P19).',
      revisionLag: 'revisión {applied} aplicada de {current}',
      updatedInstances: '{updated}/{desired} instancias en esta revisión'
    }
  }
}
